import { useEffect, memo, useState } from "react";

const RemainingTime = memo(({ handleRedirect, translate, isRedirected }) => {
  const [time, setTime] = useState(15);
  let timeout;

  const handleTimer = () => {
    !isRedirected && setTime(time - 1);
  };
  useEffect(() => {
    if (time > 0) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      timeout = setTimeout(handleTimer, 1000);
    } else {
      handleRedirect(true);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [time]);

  return `${translate("redirect")} ${time} ${translate("second")}`;
});

export default RemainingTime;
